import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Header from "../OrderManagement/Header";
import { Box, Typography, CircularProgress, Button, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import InboxIcon from "@mui/icons-material/Inbox";
import { headers } from "../../utils/utils";
import CustomerShowPage from "../Customer/Show";

const List = () => {
  const [customerList, setCustomerList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [totalCustomerCount, setTotalCustomerCount] = useState(0);

  useEffect(() => {
    fetchCustomerList();
  }, [paginationModel]);

  if (selectedRow) {
    return <CustomerShowPage id={selectedRow.id} />;
  }

    const columns = [
        { field: 'customerCode', headerName: 'Code', flex: 1 },
        { field: 'customerName', headerName: 'Name', flex: 2 },
        { field: 'customerEmail', headerName: 'Email', flex: 2 },
        { field: 'customerPhoneNumber', headerName: 'Phone Number', flex: 2 },

    ];

  const fetchCustomerList = async (
    page = paginationModel.page,
    pageSize = paginationModel.pageSize,
  ) => {
    if (
      customerList.length !== totalCustomerCount ||
      customerList.length === 0
    ) {
      if (pageSize !== totalCustomerCount) setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_CUSTOMER}/customer/list?pageNumber=${page}&pageSize=${pageSize}`,
          {
            method: "POST",
            body: JSON.stringify({}),
            headers: headers(),
          },
        );

        if (response.ok) {
          const result = await response.json();
          setTotalCustomerCount(result.totalElements);

          const updatedCustomer = await Promise.all(
            result.content.map(async (customer) => {
              return {
                ...customer,
              };
            }),
          );
          setCustomerList(updatedCustomer);
        } else {
          throw new Error("Failed to fetch customers");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
  };
  const handleFilterModelChange = () => {
    fetchCustomerList(0, totalCustomerCount);
  };

  return (
    <div style={{ background: "white" }}>
      <Header />
      <Box
        p={3}
        sx={{
          margin: "20px",
          boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
          borderRadius: "10px",
          background: "white",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          padding="16px"
        >
          <Typography
            variant="h6"
            style={{ display: "flex", alignItems: "center" }}
          >
            <Link
              href="/order1"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <InboxIcon style={{ marginRight: "8px" }} />
              Customer
            </Link>
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            component={RouterLink}
            to="/new-customer"
          >
            New Customer
          </Button>
        </Box>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box sx={{ display: "flex", justifyContent: "center", color: "red" }}>
            <Typography variant="body2">{error}</Typography>
          </Box>
        ) : (
          <DataGrid
            rows={customerList}
            columns={columns}
            paginationModel={paginationModel}
            pageSizeOptions={[5, 10]}
            rowCount={totalCustomerCount}
            onFilterModelChange={handleFilterModelChange}
            onRowClick={(params) => setSelectedRow(params.row)}
            paginationMode="server"
            onPaginationModelChange={(newModel) => {
              setPaginationModel(newModel);
              fetchCustomerList(newModel.page, newModel.pageSize);
            }}
            pagination
            rowHeight={90}
            components={{
              Footer: () => (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "8px",
                  }}
                >
                  <Typography variant="body2">
                    Total Items: {totalCustomerCount}
                  </Typography>
                  <Typography variant="body2">
                    Page: {paginationModel.page + 1} of{" "}
                    {Math.ceil(totalCustomerCount / paginationModel.pageSize)}
                  </Typography>
                </Box>
              ),
            }}
            sx={{
              border: 0,
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#f5f5f5",
                cursor: "pointer",
              },
            }}
          />
        )}
      </Box>
    </div>
  );
};

export default List;
